import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import { LinearProgress, TextField } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import DialogBox from "../../component/DialogBox";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import AccrodianBox from "../../component/AccrodianBox";
import ControlledCircularProgress from "../../component/ControlledCircularProgress";

function CompanyGoalManagement() {
  const [taskData, setTaskData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [reload, setReload] = useState(false);
  const [totalWeight, setTotalWeight] = useState(0);

  // fetch company task
  async function getCompanyTask() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/tasks/company`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setTaskData(res.data?.data);
      let totalW = 0;
      res.data?.data?.map((weight) => {
        totalW += weight?.weight;
      });
      setTotalWeight(totalW);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Task fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // add task
  async function addTask() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/company/goal/task/add`,
        method: "post",
        data: {
          title: title,
          description: description,
          weight: weight,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Task added successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // edit task
  async function editTask(prevTitle) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/company/goal/task/edit`,
        method: "put",
        data: {
          title: title,
          description: description,
          weight: weight,
          prevTitle: prevTitle
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Task added successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // delete task
  async function deleteTask(data) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/company/goal/task/delete`,
        method: "delete",
        data: {
          taskData: {
            title: data?.title,
            description: data?.description,
            weight: data?.weight,
          },
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Task deleted successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set value for edit
  function setValue(data) {
    setTitle(data?.title);
    setDescription(data?.description);
    setWeight(Number(data?.weight));
  }

  useEffect(() => {
    getCompanyTask();
  }, [reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] lg:w-[50rem] py-5">
          <h1 className="text-[20px] sm:text-[30px] font-medium text-left w-full">
            Goal Management
          </h1>
          <div className="flex justify-center items-center mt-5">
            <ControlledCircularProgress
              value={totalWeight}
              size={"130px"}
              thickness={10}
              className={`${
                totalWeight === 100 ? "!text-green-500" : "!text-blue-500"
              }`}
            />
          </div>
          <div className="mt-5 py-5">
            {taskData?.length === 0 ? (
              <div className="flex justify-center items-center flex-col gap-2">
                <p className="text-center text-slate-400 font-medium">
                  No task added yet
                </p>
                <DialogBox
                  trigger={
                    <ButtonCompo variant={"outlined"}>Add Task</ButtonCompo>
                  }
                  title="Add A Task"
                  actionButton={
                    <ButtonCompo onClick={addTask}>Save</ButtonCompo>
                  }
                  closeActionButton={<ButtonCompo>close</ButtonCompo>}
                >
                  <div className="w-full space-y-3">
                    <InputField
                      label="Title"
                      onChange={(event) => setTitle(event?.target?.value)}
                    />
                    <TextField
                      label="Description"
                      className="!w-full"
                      multiline
                      onChange={(event) => setDescription(event?.target?.value)}
                    />
                    <InputField
                      label="Weight(in %)"
                      type="number"
                      onChange={(event) => setWeight(event?.target?.value)}
                    />
                  </div>
                </DialogBox>
              </div>
            ) : (
              <div className="w-full py-5">
                <div className="flex justify-end w-full">
                  <DialogBox
                    trigger={
                      <ButtonCompo variant={"outlined"}>Add Task</ButtonCompo>
                    }
                    title="Add A Task"
                    actionButton={
                      <ButtonCompo onClick={addTask}>Save</ButtonCompo>
                    }
                    closeActionButton={<ButtonCompo>close</ButtonCompo>}
                  >
                    <div className="w-full space-y-3">
                      <InputField
                        label="Title"
                        onChange={(event) => setTitle(event?.target?.value)}
                      />
                      <TextField
                        label="Description"
                        className="!w-full"
                        multiline
                        onChange={(event) =>
                          setDescription(event?.target?.value)
                        }
                      />
                      <InputField
                        label="Weight(in %)"
                        type="number"
                        onChange={(event) => setWeight(event?.target?.value)}
                      />
                    </div>
                  </DialogBox>
                </div>
                <div className="mt-5 w-full">
                  {taskData?.map((e, i) => (
                    <AccrodianBox title={e?.title} headClass={"!font-semibold"}>
                      <div className="w-full space-y-2">
                        <section>
                          <label className="text-[15px] font-medium">
                            Weight
                          </label>
                          <p className="text-slate-500">{e?.weight}%</p>
                        </section>
                        <section>
                          <label className="text-[15px] font-medium">
                            Description
                          </label>
                          <p className="text-slate-500">{e?.description}</p>
                        </section>
                      </div>
                      <div className="w-full flex justify-end">
                        <DialogBox
                          trigger={
                            <ButtonCompo onClick={() => setValue(e)}>
                              edit
                            </ButtonCompo>
                          }
                          title="Add A Task"
                          actionButton={
                            <ButtonCompo onClick={() => editTask(e?.title)}>Save</ButtonCompo>
                          }
                          closeActionButton={<ButtonCompo>close</ButtonCompo>}
                        >
                          <div className="w-full space-y-3">
                            <InputField
                              label="Title"
                              onChange={(event) =>
                                setTitle(event?.target?.value)
                              }
                              value={title}
                            />
                            <TextField
                              label="Description"
                              className="!w-full"
                              multiline
                              onChange={(event) =>
                                setDescription(event?.target?.value)
                              }
                              value={description}
                            />
                            <InputField
                              label="Weight(in %)"
                              type="number"
                              onChange={(event) =>
                                setWeight(event?.target?.value)
                              }
                              value={weight}
                            />
                          </div>
                        </DialogBox>
                        <ButtonCompo color={"error"} onClick={() => deleteTask(e)}>delete</ButtonCompo>
                      </div>
                    </AccrodianBox>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyGoalManagement;
